module.exports = __webpack_public_path__ + "static/opinions-e021f0da7f54cc420782bcd00d68127a.svg";